import { lazy, Suspense, useEffect, useState } from 'react'
import { router } from '@inertiajs/react'
import { useInputCenter } from './inputCenterStore'

const InputCenter = lazy(() => import('./InputCenter'))

// Mounted once beside <App> (inertia.tsx), like AgentMount, so the bar and
// its draft survive page visits. Its code is its own chunk, fetched only for
// people who are signed in.
export default function InputCenterMount({ signedIn: initiallySignedIn }: { signedIn: boolean }) {
  const [signedIn, setSignedIn] = useState(initiallySignedIn)

  useEffect(
    () =>
      router.on('navigate', (event) => {
        const props = event.detail.page.props as { auth?: { user?: unknown } }
        if ('auth' in props) setSignedIn(Boolean(props.auth?.user))
      }),
    [],
  )

  // Reserve room under the page's scroll areas so the bar never covers the
  // last rows (the task page's 留言 block was hidden behind it). Layouts read
  // --input-center-space; it is 0 when the bar is not mounted — and now also
  // when the bar is collapsed into the header, which is the default.
  const { expanded, pinned } = useInputCenter()
  useEffect(() => {
    if (!signedIn) return
    document.documentElement.style.setProperty('--input-center-space', expanded || pinned ? '88px' : '0px')
    return () => {
      document.documentElement.style.removeProperty('--input-center-space')
    }
  }, [signedIn, expanded, pinned])

  if (!signedIn) return null
  return (
    <Suspense fallback={null}>
      <InputCenter />
    </Suspense>
  )
}
